import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {PivotGridModel} from "../pivot-grid.model";
import {PopParentHorizontalAlignment} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-bi-pivot-grid",
    templateUrl: "./pivot-grid.component.html",
    styleUrls: ["./pivot-grid.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PivotGridComponent implements OnInit, OnDestroy {
    PopParentHorizontalAlignment = PopParentHorizontalAlignment;

    @Input() height: number = 450;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: PivotGridModel, private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.model.dataUpdatedSubject.subscribe(() => this.changeDetectorRef.markForCheck()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    trackByFn(index, item) {
        return index;
    }

}
